const QUERY_STORAGE_KEY = 'rshb-query-params';
export function saveSessionQuery() {
    const result = globalThis.location?.search || globalThis.sessionStorage?.getItem(QUERY_STORAGE_KEY) || '';
    if (result) {
        globalThis.sessionStorage?.setItem(QUERY_STORAGE_KEY, result);
    }
    return result;
}
//# sourceMappingURL=getSessionQuery.js.map